import { render, staticRenderFns } from "./solutionPage.vue?vue&type=template&id=18f6a5eb&scoped=true"
import script from "./solutionPage.vue?vue&type=script&lang=js"
export * from "./solutionPage.vue?vue&type=script&lang=js"
import style0 from "./solutionPage.vue?vue&type=style&index=0&id=18f6a5eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6a5eb",
  null
  
)

export default component.exports